<template>
    <v-checkbox class="mt-0 mb-0" hide-details :id="$attrs.label?$helper.slugify($attrs.label):null" v-on="$listeners" v-bind="$attrs"></v-checkbox>
</template>
<script>
    export default {
        name: 'eod-checkbox'
    }
</script>